import axiosConfig from './config';

export const getWebSocketSoundNotifications = async () => await axiosConfig.get('web-socket-sound-notification/list');
